import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import config from 'config';
import axios from '../lib/axios';

import { InlineSVG, Date, Popup, Content, PhotoSwipeWrapper } from '../components';

export default class NoticeDetail extends Component {
	constructor(props){
		super(props);
		this.state = { isLoading: true, notice: false };
	}

	componentWillMount() {
		const { slug } = this.props.match.params;
		axios.get(`/notices/${slug}`)
		.then(response => this.setState({isLoading: false, notice: response.data}))
		.catch(err => this.setState({isLoading: false}))
	}

	render() {
		const { notice, isLoading } = this.state;
	    return (
		<Popup id="popup-post-detail"
	        title="Avisos"
	        subtitle=""
	        onClose={() => this.props.history.goBack()}
	        titleElement={this.props.titleElement}
	    >
	        <div className="wrapper">
	        { notice &&
	          <div>
	            <section className="content">
		            <div className="date-share-wrapper">
		            	<Date date={notice.date} />
		            </div>
		            <h1>{notice.title}</h1>
		            <Content content={notice.description} />
	            </section>
	          </div>
	        }
	        </div>
	      </Popup>
	    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/NoticeDetail.js